module.exports = __webpack_public_path__ + "img/accessory-1@2x.c1b4b57f.png";